import React from 'react';

import PrivateChat from '../../../components/PrivateChat/PrivateChat';

import './PrivateMessaging.css';
import AnchorDashboardHeader from '../../../components/AnchorDashboardHeader/AnchorDashboardHeader';


const PrivateMessaging = () => (
  <div className="anchor-dashboard-min-height" id="anchor-dashboard-private-chat">
    <AnchorDashboardHeader heading={'Messages'} />
    <div className="container anchor-dashboard-private-chat-container">
      <PrivateChat />
    </div>
  </div>
);

export default PrivateMessaging;
